import { Link as RemixLink } from "@remix-run/react";
import { Box, Link, Text } from "@chakra-ui/react";

/**
 * Facility-specific SEO context for featured pages: an editorial blurb and
 * (optionally) a booking-guide link. Deliberately the lowest-prominence block
 * on the page — it renders as headingless footer-style text *below* the closing
 * CTA (and outside the divided section stack), so the SEO copy is present
 * without competing with the calendar/CTA. Renders nothing without a blurb or
 * guide.
 */
export function FacilityAbout({ name, blurb, blogPostSlug }) {
  if (!blurb && !blogPostSlug) return null;

  return (
    <Box
      px={{ base: 4, md: 0 }}
      maxW="container.sm"
      mx="auto"
      w="100%"
      textAlign="center"
    >
      {blurb && (
        <Text fontSize="sm" color="subtle" lineHeight="1.7">
          {blurb}
        </Text>
      )}
      {blogPostSlug && (
        <Text fontSize="sm" mt={2}>
          <Link
            as={RemixLink}
            to={`/blog/${blogPostSlug}`}
            color="accent"
            fontWeight="semibold"
          >
            Read our {name} booking guide &rarr;
          </Link>
        </Text>
      )}
    </Box>
  );
}
